import { route } from '@md/routing';
import { leads } from '@md/leads/api';
import { accessPermission } from '@md/users/permissions';
import {
  LEADS_VIEW_LIST,
  LEADS_EDIT,
  LEADS_CREATE,
} from '@md/leads/accessTokens';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');

const LEADS_PREFIX = 'cabinet:leads:';
const p = name => LEADS_PREFIX + name;
const LIST = p('list');
const EDIT = p('edit');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(LEADS_VIEW_LIST, options),
    }),
    route('create/', Create, p('create'), {
      meta: accessPermission(LEADS_CREATE, options),
    }),
    receiveRoute(leads.retrieve, [
      route('edit/', Edit, EDIT, {
        meta: accessPermission(LEADS_EDIT, options),
      }),
      { path: '', redirect: { name: EDIT } },
    ]),

    { path: '', redirect: { name: LIST } },
  ];
}
